
import { defineComponent, onMounted, ref, computed } from 'vue'
import { useRoute } from 'vue-router';
import { useStore } from "vuex";
import { useI18n } from "vue-i18n/index";
//componentes
import btnBack from "@/components/buttons/btnBack.vue"
import UploadFileModal from "@/components/modals/general/UploadFileModal.vue"

//services
import InstitutionService from "@/core/services/InstitutionService"

export default defineComponent({
    name: "manager-clubs",
    components: { btnBack, UploadFileModal },
    setup() {
        const { t } = useI18n();
        const store = useStore();
        const loader = ref(false);
        const route = useRoute();
        const { id } = route.params;
        const REPO = ref(process.env.VUE_APP_REPO);
        const club = ref<any>({});
        const paramsUpload = ref<any>({});
        const uploadPhotoRef = ref<any>(null);

        const company = computed(() => {
            return store.getters.currentUser.company
        })

        const getInfo = async()=> {
            loader.value = true
            await InstitutionService.edit(id.toString())
            .then((res)=>{
                club.value = res.data
                loader.value = false
            }).catch(({response})=>{
                loader.value = false
            })
        };

        const openUpload = () => {
            if(uploadPhotoRef.value){
                paramsUpload.value.id = btoa(club.value.idinstitution);
                paramsUpload.value.alias    = 'AVATAR';
                paramsUpload.value.folder   = 'unis';
                paramsUpload.value.destiny  = 'institution'; 
                uploadPhotoRef.value.openModal();
            }
        }

        const uploadResponse = (data: any) => {
            if(data.status == 'success') getInfo();
        }

        onMounted(()=>{
            getInfo()
        })
    
    return {
            t,
            id,
            loader,
            REPO,
            company,
            club,
            uploadPhotoRef,
            paramsUpload,
            //events
            getInfo,
            openUpload,
            uploadResponse
        }
    },
})
